import React from 'react';
import { NaicsCodeAuto } from "areas/shared/controls";
import { Button } from 'fw/components';
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

class BusinessNAICSCodes extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            naicsCodes: props.naicsCodes
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            naicsCodes: nextProps.naicsCodes
        });
    }

    handleRemove = (e, index) => {
        e.preventDefault();
        this.props.onRemove(index);
    }

    onChange = (index, label, e) => {
        var item = this.state.naicsCodes[index];

        if(label !== '') {
            item['naicsCodeId'] = e.value;
            item['naicsDescription'] = label;

            this.props.onChange(index, item);
        } else {
            var naicsCodes = this.state.naicsCodes;
            item['naicsCodeId'] = 0
            item['naicsDescription'] = "";
            this.setState({naicsCodes});
        }
    }
    
    render() {
        let me = this;
        let rows = this.state.naicsCodes.map(function (item, index) {
            return (
                <div key={index} >
                    <Row style={{ marginBottom: "2px" }}>
                        <Col md={11}>                                    
                            <NaicsCodeAuto                                
                                value={item.naicsCodeId}
                                text={item.naicsDescription}
                                placeholder='Search NAICS Code...'
                                onChange={e => me.onChange(index, e != null ? e.label : '', e)}
                                /> 
                                <br />
                        </Col>
                        <Col md={1} style={{ marginTop: 0, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
                            {index > 0 &&
								<Button type="button" bsStyle="link" onClick={(e) => me.handleRemove(e, index)}>
									<FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
								</Button>
                            }
                        </Col>
                    </Row>
                </div>
            );
        });

        return (
            <React.Fragment>
                {rows}
            </React.Fragment>
        );
    }
}

export default BusinessNAICSCodes;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/businessStructure/businessNAICSCodes.js